// extracted by mini-css-extract-plugin
export var cardLayout = "_20-1";
export var paginationContainer = "_20-0";